import { yupResolver } from "@hookform/resolvers/yup";
import { KeyRound, Mail } from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { loginFormValidationSchema } from "../../utils/validationSchema";
import Button from "../Reusable/Button";
import PasswordField from "../Reusable/Form/PasswordInput";
import TextField from "../Reusable/Form/TextInput";
import Modal from "../Reusable/Modal";
import CreateUser from "./CreateUser";

const LoginForm = (props: any) => {
  const [openCreateUserPopup, setOpencreateUserPopup] = useState(false);

  const { handleSubmit, setError, control } = useForm<any>({
    resolver: yupResolver(loginFormValidationSchema),
  });

  const { handleLogin, isLoading, checkUser } = props;

  useEffect(() => {
    if (checkUser?.status) {
      setOpencreateUserPopup(!openCreateUserPopup);
    }
  }, [checkUser]);

  return (
    <>
      <form
        onSubmit={handleSubmit((data) => handleLogin(data, setError))}
        autoComplete="off"
      >
        <TextField
          label={"Username / Email / Phone Number"}
          icon={<Mail color="gray" strokeWidth={2} />}
          control={control}
          name="email"
        />
        <PasswordField
          label={"Password"}
          icon={<KeyRound color="gray" strokeWidth={2} />}
          control={control}
          name="password"
        />
        <Button type={"submit"} label={"Login"} isLoading={isLoading} />
      </form>
      <div className={tw`w-full text-right px-4 text-red-600`}>
        <Link to="/forget-password">Forget Password?</Link>
      </div>
      <Modal
        isOpen={openCreateUserPopup}
        setIsOpen={setOpencreateUserPopup}
        title={"Create First User"}
        children={
          <>
            <CreateUser
              setOpencreateUserPopup={setOpencreateUserPopup}
              openCreateUserPopup={openCreateUserPopup}
            />
          </>
        }
      />
    </>
  );
};

export default LoginForm;
